import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges
} from "@angular/core";
import { ControlContainer, NgForm } from "@angular/forms";
import { QueryOptions } from "@app/model/query-options";

@Component({
  selector: "app-dropDown",
  templateUrl: "./dropDown.component.html",
  styleUrls: ["./dropDown.component.css"],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class DropDownComponent implements OnInit {

  formName: string = "";
  showErrorMessage = false;
  options: any[] = [];
  defaultVal: any;
  errorMesage:any;
  testTech: "9414a158-ed4b-4f02-950d-2232a769efd8";
  @Input() label: String;
  @Input() disable: any;
  @Input() value: any;
  @Input() name: string;
  @Input() apiService: any;
  @Input() openJDModalRequiredError: boolean;
  @Output() onSelect = new EventEmitter<string>();
  pageSize: number = 100;
  first: number = 0;
 
  @Input()
  set selectedValue(val: any) {
    if (val !== undefined) {
      this.load(val);
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      if (propName == "disable") {
        let change = changes[propName];
        let curVal = JSON.stringify(change.currentValue);
        let prevVal = JSON.stringify(change.previousValue);
        if (!curVal) this.disable = false;
      }
    }
  }
  constructor() {}
  onChange(event) {
    this.onSelect.emit(event.value.value);
    if (event.value.value == null){ this.showErrorMessage = true;}else{
      this.showErrorMessage = false;
      this.openJDModalRequiredError=false;
    }
  }
  ngOnInit() {
    this.formName = this.name;
    this.load(this.value);
  }

  load(val: any) {
    let queryParams = new Object();
    //sort order as number, 1 for asc and -1 for dec
    queryParams["sortParam"] = { sortField: "name", sortOrder: 1 };
    queryParams["pageParam"] = {
      page:
        this.first / this.pageSize > 1
          ? this.first / this.pageSize + 1
          : this.first / this.pageSize,
      size: this.pageSize
    };
    let dropDownSortingQueryOptions = new QueryOptions(queryParams);
    dropDownSortingQueryOptions.toQueryMap(); // for passing request params. this is the job id
    this.apiService.list(dropDownSortingQueryOptions).subscribe(res => {
      this.options = res;

      if (this.disable) {
        var filteredObj = this.options.filter(function(item) {
          return "Open" == item.label;
        });
        this.value = filteredObj[0];
        this.onSelect.emit(this.value.value);
      } else {
        this.disable = false;
        this.options.unshift({
          label: "Select" + " " + this.label,
          value: null
        });
      }
      if (val != undefined) {
        var filteredObj = this.options.filter(function(item) {
          return val == item.value;
        });
        this.value = filteredObj[0];
      }
    });
  }
}
